import { config } from "../../utils/constants";
import axios from "axios";

export const getSickLeavePaymentUrl = (transId) => {
  const requestConfig = {
    url: `${config.paymentServices}tnemyapals`,
    method: `POST`,
    data: {
      transId: transId
    }
  };
  // console.log("getPaymentUrl Request ::: ", requestConfig);
  sessionStorage.setItem("redirectedFromPayment", "true");
  return axios.request(requestConfig);
};

export const getMedicalReportPaymentUrl = (transId) => {
  const requestConfig = {
    url: `${config.paymentServices}tnemyaprm`,
    method: `POST`,
    data: {
      transId: transId
    }
  };
  // console.log("getPaymentUrl Request ::: ", requestConfig);
  sessionStorage.setItem("redirectedFromPayment", "true");
  return axios.request(requestConfig);
};

export const getRenewHealthCardPaymentUrl = (code) => {
  const requestConfig = {
    url: `${config.paymentServices}tnemyapspn?code=${code}`,
    method: `POST`,
    data: {
      transId: ""
    }
  };
  // console.log("getPaymentUrl Request ::: ", requestConfig);
  sessionStorage.setItem("redirectedFromPayment", "true");
  return axios.request(requestConfig);
};
export const getPaymentUrl = (servCode, transId) => {
  const requestConfig = {
    url: `${config.paymentServices}get-payment-url`,
    method: `POST`,
    data: {
      servCode: servCode,
      transId: transId
    }
  };
  // console.log("getPaymentUrl Request ::: ", requestConfig);
  sessionStorage.setItem("redirectedFromPayment", "true");
  return axios.request(requestConfig);
};

export const getPaymentHistory = (page = 1, pageSize = 10, type) => {
  const requestConfig = {
    method: 'post',
    url: `${config.paymentServices}payment-history`,
    data: {
      page: page,
      pageSize: pageSize,
      salamaRequestType: type
    }
  };

  return axios.request(requestConfig)
  .then((response) => response)
  .catch((error) => {
    console.error("Error fetching payment history:", error);
    throw error;
  });
};